import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

// ✅ Kateqoriyaya görə məhsullar
export const get_digital_products_by_category = createAsyncThunk(
    'digitalProduct/get_digital_products_by_category',
    async ({ category, subCategory }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/digital-products/category?category=${category}${subCategory ? `&subCategory=${subCategory}` : ''}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ Slug ilə məhsul
export const get_digital_product_details = createAsyncThunk(
    'digitalProduct/get_digital_product_details',
    async (slug, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/digital-products/${slug}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ Digital order yarat
export const place_digital_order = createAsyncThunk(
    'digitalProduct/place_digital_order',
    async (orderData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/home/digital-products/order', orderData)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ Kateqoriyalar
export const get_digital_categories = createAsyncThunk(
    'digitalProduct/get_digital_categories',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/digital-products/categories')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ Rəsmi kateqoriyalar (oyun səhifələri)
export const get_official_categories = createAsyncThunk(
    'digitalProduct/get_official_categories',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/official-categories')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta' })
        }
    }
)

export const get_official_category = createAsyncThunk(
    'digitalProduct/get_official_category',
    async (slug, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/official-categories/${slug}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta' })
        }
    }
)

// ✅ Katalog V2 — ana səhifə xidmət kartları (packageCount/minPrice/stockStatus)
export const get_official_home_services = createAsyncThunk(
    'digitalProduct/get_official_home_services',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/official-services')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta' })
        }
    }
)

// ✅ Level-2 xidmət səhifəsinin paketləri
export const get_official_service = createAsyncThunk(
    'digitalProduct/get_official_service',
    async ({ catSlug, serviceSlug }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/official-categories/${catSlug}/services/${serviceSlug}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta' })
        }
    }
)

// ✅ Rəsmi digital çekaut (balansla) — adminDigitalOrder yaradır + kod çatdırır
export const official_checkout = createAsyncThunk(
    'digitalProduct/official_checkout',
    async (payload, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/user/official-checkout', payload)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Ödəniş uğursuz' })
        }
    }
)

export const digitalProductReducer = createSlice({
    name: 'digitalProduct',
    initialState: {
        products: [],
        product: {},
        categories: [],
        subCategories: [],
        officialCategories: [],
        officialCategory: null,
        officialProducts: [],
        officialServices: [],
        officialService: null,
        officialServiceProducts: [],
        officialServiceContent: null,
        officialHomeServices: [],
        checkoutOrder: null,
        loader: false,
        checkoutLoading: false,
        errorMessage: '',
        successMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            // Get products by category
            .addCase(get_digital_products_by_category.pending, (state) => {
                state.loader = true
            })
            .addCase(get_digital_products_by_category.fulfilled, (state, { payload }) => {
                state.loader = false
                state.products = payload.products
            })
            .addCase(get_digital_products_by_category.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message
            })
            // Get product details
            .addCase(get_digital_product_details.pending, (state) => {
                state.loader = true
            })
            .addCase(get_digital_product_details.fulfilled, (state, { payload }) => {
                state.loader = false
                state.product = payload.product
            })
            .addCase(get_digital_product_details.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message
            })
            // Place order
            .addCase(place_digital_order.pending, (state) => {
                state.loader = true
            })
            .addCase(place_digital_order.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
            .addCase(place_digital_order.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message
            })
            // Get categories
            .addCase(get_digital_categories.fulfilled, (state, { payload }) => {
                state.categories = payload.categories
                state.subCategories = payload.subCategories
            })
            // ✅ Rəsmi kateqoriyalar
            .addCase(get_official_categories.pending, (state) => { state.loader = true })
            .addCase(get_official_categories.fulfilled, (state, { payload }) => {
                state.loader = false
                state.officialCategories = payload.categories || []
            })
            .addCase(get_official_categories.rejected, (state) => { state.loader = false })
            // ✅ Katalog V2 — ana səhifə xidmətləri (ayrı loader istifadə etmir — bölmə öz fallback-ı ilə render olunur)
            .addCase(get_official_home_services.fulfilled, (state, { payload }) => {
                state.officialHomeServices = payload.services || []
            })
            .addCase(get_official_category.pending, (state) => { state.loader = true; state.officialCategory = null; state.officialProducts = []; state.officialServices = [] })
            .addCase(get_official_category.fulfilled, (state, { payload }) => {
                state.loader = false
                state.officialCategory = payload.category || null
                state.officialProducts = payload.products || []
                state.officialServices = payload.services || []
            })
            .addCase(get_official_category.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message
            })
            // ✅ Level-2 xidmət paketləri
            .addCase(get_official_service.pending, (state) => { state.loader = true; state.officialCategory = null; state.officialService = null; state.officialServiceProducts = []; state.officialServiceContent = null })
            .addCase(get_official_service.fulfilled, (state, { payload }) => {
                state.loader = false
                state.officialCategory = payload.category || state.officialCategory
                state.officialService = payload.service || null
                state.officialServiceProducts = payload.products || []
                state.officialServiceContent = payload.content || null
            })
            .addCase(get_official_service.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message
            })
            // ✅ Rəsmi çekaut
            .addCase(official_checkout.pending, (state) => { state.checkoutLoading = true })
            .addCase(official_checkout.fulfilled, (state, { payload }) => {
                state.checkoutLoading = false
                state.successMessage = payload.message
                state.checkoutOrder = payload.order || null
            })
            .addCase(official_checkout.rejected, (state, { payload }) => {
                state.checkoutLoading = false
                state.errorMessage = payload?.message || 'Ödəniş uğursuz'
            })
    }
})

export const { messageClear } = digitalProductReducer.actions
export default digitalProductReducer.reducer
